import { createAction } from "redux-actions";
import { makeActionType } from "../utils";
import { urls } from "../constants/app";
import { resetError, setError } from "./errors";
import request from './utils/request';

const namespace = 'POINTS';

export const setPoints = createAction(makeActionType(namespace, ['SET']));
export const setCountPoints = createAction(makeActionType(namespace, ['SET', 'COUNT']));

export function fetchPoints(withoutLoader = false, force = false) {
    return async (dispatch, getState) => {
        const { points } = getState();

        if (!force && points.items && points.items.length > 0) {
            return;
        }

        !withoutLoader && dispatch({ type: 'SET_LOADER', field: 'points', value: true });
        dispatch(resetError('points'));
        try {
            const points = await request({ method: 'get', url: urls.filials });
            const enrichedPoints = points.map(point => ({
                ...point,
                city: point.city || { name: 'Неизвестный город' },
            }));

            dispatch(setPoints(enrichedPoints));
            dispatch(setCountPoints(enrichedPoints.length));
        } catch (error) {
            dispatch(setError(error, 'points'));
        } finally {
            !withoutLoader && dispatch({ type: 'SET_LOADER', field: 'points', value: false });
        }
    };
}
